import BrokerWallet from "./BrokerWallet";
import { useUserFeature } from "hooks/useUserFeature";
import StripeWallet from "./StripeWallet";

export default function Wallet() {
  const { isStripeEnabled } = useUserFeature();
  return isStripeEnabled ? <StripeWallet /> : <BrokerWallet />;
}
